export default __webpack_public_path__ + "static/media/tigerfish.3d36133f.PNG";